import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Group} from '../../graphql/groups.datatypes';

interface GroupData {
    groupByRef: Group
}

export const gqlGroup = `
    id
    tour_resource_id
    hotel_resource_id
    name
    description
    description_resort
    description_whats_included
    description_checkin
    editing_level
    start_date
    start_date_additional
    end_date
    end_date_additional
    max_additional_nights
    booking_form_url
    invoice_document_id
    convenience_fee
    credit_card_fee
    comp_dollar_value
    comp_ratio
    comp_dollar_estimate
    comp_final_value
    admissions_cutoff
    default_authorize_members
    validated
    disabled
    locked
    booking_tool_edit_cutoff
    description_insurance

    hasPrimaryLeader
    hasLeader

    tour {
      id
      display_name
      internal_name
      available_from
      available_to
      description
      image_logo_url
      image_banner_url
      comms_email_address
      contact_us_message

      rain_date_note
      cancellation_policy
      terms_and_conditions

      tour_roles {
        id
        tour_resource_id
        tour_role
        age_lower_bound
        age_upper_bound
      }
    }

    hotel {
      id
      internal_name
      display_name

      resource_banks {
        id
        unit_price
        remaining
      }

      roomResources {
        id
        internal_name
        guest_capacity

        resource_banks {
            id
            capacity
            date
            remaining
            warning_count
        }
      }
    }

    options {
      id
      mandatory
      resource_option_id
      group_id
      action_type
      unitCost
      is_hidden
      is_additional_charge

      option {
          id
          resource_id
          internal_name
          display_name
          description
          disabled
          hidden
          additional_charge
          target
          action_type
          action_value

          resource {
              id
              internal_name
              display_name
              description
              has_price
              consumable
              allow_multiple
              allow_manual_overbooking

              resource_banks(orderBy: [{column: "date", order: ASC}]) {
                  id
                  resource_id
                  capacity
                  remaining
                  warning_count
                  unit_price
                  date
              }
          }

          conditions {
            id
            type
            attribute
            attribute_type
            attribute_value
            condition
          }
      }
    }

    payment_schedule {
        id
        description
        dates {
            id
            title
            due_date
            action_type
            amount
            amount_type
            completed
        }
    }

    optionIds
`;

export const GET_GROUP_QUERY = gql`
    query getGroupByRef($booking_form_url: String!){
        groupByRef(booking_form_url: $booking_form_url){
          ${gqlGroup}
        }
    }
`;

export const getGroupByRef = (groupRef: string) => {
    return useQuery<GroupData>(
        GET_GROUP_QUERY,
        {
            variables: {booking_form_url: groupRef},
        }
    );
};

export default getGroupByRef;
